import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const dashboardPath = user.role === 'seller' ? '/seller/dashboard' : '/buyer/dashboard';

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h1 data-testid="cancel-heading" className="text-2xl font-chivo font-bold text-slate-900 mb-2">
          Payment Cancelled
        </h1>
        <p className="text-slate-600 mb-6">
          Your payment was cancelled. No charges were made.
        </p>
        <div className="space-y-3">
          <Button
            data-testid="try-again-btn"
            className="w-full"
            onClick={() => navigate('/checkout')}
          >
            Try Again
          </Button>
          <Button
            data-testid="back-to-dashboard-btn"
            variant="outline"
            className="w-full"
            onClick={() => navigate(dashboardPath)}
          >
            Back to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancel;
